import ChartScatter from './ChartScatter';
import './ChartScatter.scss';

export default ChartScatter;
